/**
 * Cross-module data change events.
 *
 * This app uses service-level caching (in-memory) and offline-first storage.
 * When data mutates (create/update/delete), other mounted screens may still be
 * showing stale state unless they explicitly reload. These events provide a
 * lightweight, low-risk way to notify pages to refresh their local state.
 */

export const DATA_EVENTS = {
  ITEMS_CHANGED: 'data:items-changed',
  PARTIES_CHANGED: 'data:parties-changed',
  INVOICES_CHANGED: 'data:invoices-changed',
  PAYMENTS_CHANGED: 'data:payments-changed',
  EXPENSES_CHANGED: 'data:expenses-changed',
} as const

export type DataEventName = (typeof DATA_EVENTS)[keyof typeof DATA_EVENTS]

export const emitDataEvent = (name: DataEventName, detail?: any) => {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(name, { detail }))
}

export const onDataEvent = (name: DataEventName, handler: (detail: any) => void) => {
  const listener = (ev: Event) => handler((ev as CustomEvent).detail)
  window.addEventListener(name, listener as EventListener)
  return () => window.removeEventListener(name, listener as EventListener)
}

